import Damage from './damage/Damage';
import Hit from './hit/HIt';

export default class VFX {
    private scene: Phaser.Scene;
    private damage!: Damage;
    private hit!: Hit;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;

        this.setup();
    }

    setup() {
        this.damage = new Damage(this.scene);
        this.hit = new Hit(this.scene);
    }
}
